import { Currency } from '../../constants/currency.js';
import { getMinRateString, getAmountRangeToString } from '../../helpers/humanization.js';

const getAcquiringTerms = item => {
    // Обслуживание. Эквайринг, Итого в мес., QR-эквайринг
    const conditions = [];
    const tagQr = item.advantages?.includes('tagQr');
    conditions.push({ value: tagQr ? 'Да' : 'Нет', description: 'QR-эквайринг', key: 'qr' });
    // conditions.push({value: `от ${item.calcPriceTerm ?? 0} ₽`, description: 'Итого в месяц', key: 'calcPrice'});
    const ekvajringFields = {
        from: item.priceAcquiringS,
        to: item.priceAcquiringSto,
    };
    conditions.push({ value: `${getMinRateString(ekvajringFields, true)}`, description: 'Эквайринг', key: 'price' });
    const cost = getAmountRangeToString({
        amountRange: { from: item.calcPriceEquipment, to: null },
        currency: Currency.RUB,
        prefix: true,
    });
    conditions.push({ value: cost, description: 'Обслуживание и аренда', key: 'cost' });
    return conditions;
};

export { getAcquiringTerms };
//# sourceMappingURL=acquiring.js.map
